(() => {
  /* Discourage saving images via right-click or drag */
  document.addEventListener('contextmenu', (event) => {
    const target = event.target;
    if (target instanceof HTMLImageElement || target.closest('picture')) {
      event.preventDefault();
    }
  });

  document.addEventListener('dragstart', (event) => {
    if (event.target instanceof HTMLImageElement) {
      event.preventDefault();
    }
  });

  /* Specs table scroll reveal (product size guide) */
  document.querySelectorAll('[data-intro-reveal]').forEach((el) => {
    const reveal = () => el.classList.add('is-revealed');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveal();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal();
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
    );
    io.observe(el);

    /* Failsafe: never leave specs invisible if observer never fires */
    window.setTimeout(reveal, 1200);
  });

  /* Shared product lightbox */
  let lightbox = document.querySelector('[data-product-lightbox]');
  if (!lightbox) {
    lightbox = document.createElement('div');
    lightbox.className = 'product-lightbox';
    lightbox.setAttribute('data-product-lightbox', '');
    lightbox.innerHTML = `
      <button type="button" class="product-lightbox__close" data-product-lightbox-close aria-label="Close">&times;</button>
      <img class="product-lightbox__img" data-product-lightbox-img alt="">
    `;
    document.body.appendChild(lightbox);
  }

  const lightboxImg = lightbox.querySelector('[data-product-lightbox-img]');
  const lightboxClose = lightbox.querySelector('[data-product-lightbox-close]');

  const openLightbox = (src, alt) => {
    if (!src || !lightboxImg) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lightboxImg) lightboxImg.src = '';
  };

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
  });

  /* Header */
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const toggle = header.querySelector('[data-menu-toggle]');
    if (toggle) {
      toggle.addEventListener('click', () => {
        const open = header.classList.toggle('is-menu-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* Hero carousel */
  document.querySelectorAll('[data-hero-carousel]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const btnPrev = root.querySelector('[data-hero-prev]');
    const btnNext = root.querySelector('[data-hero-next]');

    const activeVideo = () => slides[index] && slides[index].querySelector('.hero-slide__video');

    const syncVideos = (activeIndex, restart) => {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('.hero-slide__video');
        if (!video) return;
        if (i === activeIndex) {
          if (restart) {
            try { video.currentTime = 0; } catch (err) {}
          }
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    let index = 0;
    let timer = null;
    let remaining = 0;
    let startedAt = 0;
    let pausedByUser = false;
    let holding = false;
    let waitForEnd = false;
    let pendingAdvance = false;
    let finishing = false;
    let boundVideo = null;
    let onEnded = null;
    let onTime = null;
    const autoplay = root.getAttribute('data-autoplay') === 'true';
    const interval = Number(root.getAttribute('data-interval')) || 6000;

    const clearTimer = () => {
      if (timer) window.clearTimeout(timer);
      timer = null;
    };

    const detachEnd = () => {
      if (boundVideo && onEnded) boundVideo.removeEventListener('ended', onEnded);
      if (boundVideo && onTime) boundVideo.removeEventListener('timeupdate', onTime);
      boundVideo = null;
      onEnded = null;
      onTime = null;
      waitForEnd = false;
      pendingAdvance = false;
      finishing = false;
    };

    const arm = (ms) => {
      clearTimer();
      if (!autoplay || pausedByUser || holding || slides.length < 2) return;
      remaining = ms;
      startedAt = performance.now();
      timer = window.setTimeout(() => goTo(index + 1, false), ms);
    };

    const freeze = () => {
      if (!timer) return;
      remaining = Math.max(0, remaining - (performance.now() - startedAt));
      clearTimer();
    };

    const dwellMs = (slide) => {
      const raw = (slide.getAttribute('data-hero-dwell') || '').trim();
      const seconds = Number(raw);
      if (seconds > 0) return seconds * 1000;
      return interval;
    };

    const scheduleActive = () => {
      detachEnd();
      clearTimer();
      if (!autoplay || pausedByUser || slides.length < 2) return;
      const slide = slides[index];
      const video = slide.querySelector('.hero-slide__video');
      const dwell = (slide.getAttribute('data-hero-dwell') || '').trim();
      const dwellSeconds = Number(dwell);
      const playThrough = video && (dwell === 'end' || (index === 0 && !(dwellSeconds > 0)));
      if (playThrough) {
        waitForEnd = true;
        video.loop = true;
        boundVideo = video;
        let maxTime = 0;
        const finishVideoSlide = () => {
          if (finishing || pausedByUser) return;
          if (holding) {
            pendingAdvance = true;
            return;
          }
          finishing = true;
          goTo(index + 1, false);
        };
        onTime = () => {
          const duration = video.duration;
          if (!duration || !isFinite(duration)) return;
          if (video.currentTime > maxTime) maxTime = video.currentTime;
          const loopedBack = maxTime > duration * 0.85 && video.currentTime < 0.35;
          if (loopedBack) finishVideoSlide();
        };
        video.addEventListener('timeupdate', onTime);
        video.play().catch(() => {});
        return;
      }
      if (video) video.loop = true;
      if (!holding) arm(dwellMs(slide));
    };

    const hold = () => {
      holding = true;
      freeze();
    };

    const release = () => {
      holding = false;
      if (pausedByUser) return;
      if (waitForEnd) {
        const video = activeVideo();
        if (pendingAdvance || (video && video.ended)) {
          pendingAdvance = false;
          goTo(index + 1, false);
        }
        return;
      }
      arm(remaining > 0 ? remaining : dwellMs(slides[index]));
    };

    const goTo = (next, manual) => {
      if (slides.length < 1) return;
      detachEnd();
      clearTimer();
      index = slides.length === 1 ? 0 : (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      syncVideos(index, true);
      if (manual) {
        pausedByUser = true;
        return;
      }
      scheduleActive();
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.getAttribute('data-hero-dot')) || 0, true);
      });
    });

    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        goTo(index - 1, true);
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', () => {
        goTo(index + 1, true);
      });
    }

    root.addEventListener('mouseenter', hold);
    root.addEventListener('mouseleave', release);

    goTo(0, false);
  });

  /* Product gallery */
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const zoomOpen = gallery.querySelector('[data-gallery-zoom-open]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const track = gallery.querySelector('[data-thumbs-track]');
    const btnPrev = gallery.querySelector('[data-thumbs-prev]');
    const btnNext = gallery.querySelector('[data-thumbs-next]');

    const getZoomSrc = () => main?.getAttribute('data-zoom-src') || main?.src || '';

    const setActive = (btn) => {
      const src = btn.getAttribute('data-full-src');
      const zoomSrc = btn.getAttribute('data-zoom-src') || src;
      const alt = btn.getAttribute('data-alt') || '';
      if (!src || !main) return;
      thumbs.forEach((t) => {
        t.classList.toggle('is-active', t === btn);
        t.setAttribute('aria-current', t === btn ? 'true' : 'false');
      });
      main.src = src;
      main.alt = alt;
      main.setAttribute('data-zoom-src', zoomSrc);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setActive(thumb));
    });

    const openCurrentZoom = () => {
      if (!main) return;
      openLightbox(getZoomSrc(), main.alt);
    };

    if (zoomOpen) zoomOpen.addEventListener('click', openCurrentZoom);

    const scrollThumbs = (dir) => {
      if (!track) return;
      const amount = 80;
      const isRow = getComputedStyle(track).flexDirection === 'row';
      track.scrollBy({
        top: isRow ? 0 : dir * amount,
        left: isRow ? dir * amount : 0,
        behavior: 'smooth',
      });
    };

    if (btnPrev) btnPrev.addEventListener('click', () => scrollThumbs(-1));
    if (btnNext) btnNext.addEventListener('click', () => scrollThumbs(1));
  });

  /* Product type tabs + random category products */
  document.querySelectorAll('[data-product-types]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-product-tab]')];
    const panels = [...root.querySelectorAll('[data-product-panel]')];
    const showCount = Number(root.getAttribute('data-products-to-show')) || 8;
    if (!tabs.length) return;

    const shuffle = (items) => {
      const list = [...items];
      for (let i = list.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = list[i];
        list[i] = list[j];
        list[j] = temp;
      }
      return list;
    };

    const revealRandom = (panel) => {
      if (!panel) return;
      const grid = panel.querySelector('[data-product-types-grid]');
      if (!grid) return;
      const cards = [...grid.querySelectorAll('[data-product-types-card]')];
      if (!cards.length) return;

      cards.forEach((card) => card.classList.add('is-home-hidden'));
      shuffle(cards)
        .slice(0, showCount)
        .forEach((card) => card.classList.remove('is-home-hidden'));
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const idx = tab.getAttribute('data-product-tab');
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const on = panel.getAttribute('data-product-panel') === idx;
          panel.classList.toggle('is-active', on);
          if (on) {
            panel.removeAttribute('hidden');
            revealRandom(panel);
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });

    const firstPanel = panels.find((panel) => panel.classList.contains('is-active')) || panels[0];

    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]));

    const seenHandles = new Set(
      [...root.querySelectorAll('[data-product-types-card]')].map((card) => {
        const href = card.getAttribute('href') || '';
        const handle = href.split('/products/')[1] || '';
        return handle.split('?')[0].split('#')[0];
      }).filter(Boolean)
    );

    const appendProduct = (product) => {
      const handle = product.handle;
      if (!handle || seenHandles.has(handle)) return;
      const tags = (product.tags || []).map((tag) => String(tag).toLowerCase());
      const panel = panels.find((item) => {
        const prefix = (item.getAttribute('data-tag-prefix') || '').toLowerCase();
        const alt = (item.getAttribute('data-tag-prefix-alt') || '').toLowerCase();
        return tags.some((tag) => (prefix && tag.includes(prefix)) || (alt && tag.includes(alt)));
      });
      if (!panel) return;
      const grid = panel.querySelector('[data-product-types-grid]');
      if (!grid) return;
      seenHandles.add(handle);
      const localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const image = (product.images && product.images[0]) || null;
      const imageHtml = image
        ? `<img src="${escapeHtml(image.src)}" alt="${escapeHtml(product.title || '')}" loading="lazy" width="${image.width || 800}" height="${image.height || 800}">`
        : '';
      const card = document.createElement('a');
      card.className = 'product-types__card';
      card.href = `${localeRoot}products/${handle}`;
      card.target = '_blank';
      card.rel = 'noopener noreferrer';
      card.setAttribute('data-product-types-card', '');
      card.innerHTML = `<div class="product-types__media">${imageHtml}</div><h3 class="product-types__name">${escapeHtml(product.title || '')}</h3>`;
      const empty = grid.querySelector('.product-types__empty');
      if (empty) empty.remove();
      grid.appendChild(card);
    };

    const collectionUrl = root.getAttribute('data-collection-url');
    const finish = () => {
      root.classList.remove('is-loading');
      revealRandom(firstPanel);
    };

    if (!collectionUrl) {
      finish();
      return;
    }

    (async () => {
      try {
        for (let page = 1; page <= 8; page += 1) {
          const response = await fetch(`${collectionUrl}/products.json?limit=250&page=${page}`);
          if (!response.ok) break;
          const data = await response.json();
          const products = data.products || [];
          products.forEach(appendProduct);
          if (products.length < 250) break;
        }
      } catch (error) {
        /* Keep the products already rendered by the theme. */
      }
      finish();
    })();
  });

  /* Collection sidebar filters + View more */
  document.querySelectorAll('[data-collection-layout]').forEach((layout) => {
    const sidebar = layout.querySelector('[data-collection-sidebar]');
    const form = sidebar ? sidebar.querySelector('[data-collection-filter-form]') : null;
    const searchInput = sidebar ? sidebar.querySelector('[data-collection-search]') : null;
    const loadMoreBtn = layout.querySelector('[data-load-more]');
    const loadMoreWrap = layout.querySelector('[data-load-more-wrap]');
    const grid = layout.querySelector('[data-collection-grid]');
    const initialCount = Number(layout.getAttribute('data-load-more-initial')) || 9;
    const batchSize = Number(layout.getAttribute('data-load-more-batch')) || 6;
    const defaultFilter = layout.getAttribute('data-default-filter') || 'engineered-oak';
    const collectionHandle = layout.getAttribute('data-collection-handle') || '';
    const productsCount = Number(layout.getAttribute('data-products-count')) || 0;
    const filterTags = (layout.getAttribute('data-filter-tags') || '')
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean);
    let visibleCount = initialCount;

    const syncFilterGroups = (filterValue) => {
      if (!sidebar) return;
      sidebar.querySelectorAll('[data-filter-group]').forEach((group) => {
        const match = group.querySelector(`input[value="${filterValue}"]`);
        const open = !!match;
        group.classList.toggle('is-open', open);
        const toggle = group.querySelector('[data-filter-group-toggle]');
        const panel = group.querySelector('[data-filter-group-panel]');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) {
          if (open) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        }
      });
    };

    const updateUrlParams = () => {
      const filter = getActiveFilter();
      const query = getSearchQuery();
      const url = new URL(window.location.href);
      if (filter && filter !== defaultFilter) url.searchParams.set('filter', filter);
      else url.searchParams.delete('filter');
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');
      history.replaceState({}, '', url);
    };

    const getActiveFilter = () => {
      const checked = sidebar ? sidebar.querySelector('[data-collection-filter]:checked') : null;
      return checked ? checked.value : defaultFilter;
    };

    const getSearchQuery = () => (searchInput ? searchInput.value.trim().toLowerCase() : '');

    const FILTER_ALIASES = {
      'engineered-walnut-teak': ['engineered-walnut', 'engineered-teak'],
      'herringbone-walnut-teak': ['herringbone-walnut', 'herringbone-teak'],
      'solid-walnut-teak': ['solid-walnut', 'solid-teak'],
    };

    const cardMatchesFilter = (card, filter) => {
      if (!filter) return true;
      const cardFilter = card.getAttribute('data-filter');
      const aliases = FILTER_ALIASES[filter];
      if (aliases) return aliases.includes(cardFilter);
      return cardFilter === filter;
    };

    const getMatchingCards = () => {
      const filter = getActiveFilter();
      const query = getSearchQuery();
      return [...layout.querySelectorAll('[data-collection-card]')].filter((card) => {
        const matchesFilter = cardMatchesFilter(card, filter);
        const text = card.textContent.toLowerCase();
        const matchesSearch = !query || text.includes(query);
        return matchesFilter && matchesSearch;
      });
    };

    const applyVisibility = (scrollToFirstNew, fromIndex = 0) => {
      const matching = getMatchingCards();
      const allCards = [...layout.querySelectorAll('[data-collection-card]')];

      allCards.forEach((card) => {
        card.classList.add('is-filter-hidden');
        card.classList.remove('is-load-more-hidden');
        card.removeAttribute('hidden');
      });

      let firstNew = null;
      matching.forEach((card, index) => {
        if (index < visibleCount) {
          card.classList.remove('is-filter-hidden', 'is-load-more-hidden');
          if (scrollToFirstNew && index === fromIndex) {
            firstNew = card;
          }
        } else {
          card.classList.remove('is-filter-hidden');
          card.classList.add('is-load-more-hidden');
        }
      });

      if (loadMoreWrap) {
        const hasMore = matching.length > visibleCount;
        if (hasMore) loadMoreWrap.removeAttribute('hidden');
        else loadMoreWrap.setAttribute('hidden', '');
      }

      if (scrollToFirstNew && firstNew) {
        const header = document.querySelector('[data-site-header]');
        const offset = header ? header.getBoundingClientRect().height + 16 : 16;
        const top = firstNew.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    const resetAndShow = () => {
      visibleCount = initialCount;
      applyVisibility(false);
    };

    const collectionUrl =
      layout.getAttribute('data-collection-url') ||
      (collectionHandle ? `/collections/${collectionHandle}` : '');

    const loadExtraCollectionPages = async () => {
      if (!collectionUrl || !grid || productsCount <= 250) return;

      const existing = new Set(
        [...grid.querySelectorAll('[data-collection-card]')].map((card) => {
          try {
            return new URL(card.href, window.location.origin).pathname;
          } catch (e) {
            return card.getAttribute('href') || '';
          }
        })
      );

      const maxPage = Math.ceil(productsCount / 250);
      for (let page = 2; page <= maxPage; page += 1) {
        try {
          const res = await fetch(`${collectionUrl}?view=cards&page=${page}`);
          if (!res.ok) break;
          const html = await res.text();
          if (!html || !html.trim()) break;

          const wrap = document.createElement('div');
          wrap.innerHTML = html;
          const cards = [...wrap.querySelectorAll('[data-collection-card]')];
          if (!cards.length) break;

          cards.forEach((card) => {
            try {
              const path = new URL(card.href, window.location.origin).pathname;
              if (existing.has(path)) return;
              existing.add(path);
              grid.appendChild(card);
            } catch (e) {
              grid.appendChild(card);
            }
          });
        } catch (e) {
          break;
        }
      }
    };

    if (sidebar) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlFilter = urlParams.get('filter');
      const urlQuery = urlParams.get('q') || '';

      if (urlFilter) {
        const filterInput = sidebar.querySelector(`[data-collection-filter][value="${urlFilter}"]`);
        if (filterInput) filterInput.checked = true;
      }

      if (searchInput && urlQuery) {
        searchInput.value = urlQuery;
      }

      syncFilterGroups(getActiveFilter());

      sidebar.querySelectorAll('[data-filter-group]').forEach((group) => {
        const toggle = group.querySelector('[data-filter-group-toggle]');
        const panel = group.querySelector('[data-filter-group-panel]');
        if (!toggle || !panel) return;

        toggle.addEventListener('click', () => {
          const open = !group.classList.contains('is-open');
          group.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });

      sidebar.querySelectorAll('[data-collection-filter]').forEach((input) => {
        input.addEventListener('change', () => {
          syncFilterGroups(input.value);
          updateUrlParams();
          resetAndShow();
        });
      });

      if (searchInput) {
        let searchTimer = null;
        searchInput.addEventListener('input', () => {
          window.clearTimeout(searchTimer);
          searchTimer = window.setTimeout(() => {
            updateUrlParams();
            resetAndShow();
          }, 180);
        });

        if (form) {
          form.addEventListener('submit', (event) => {
            event.preventDefault();
            updateUrlParams();
            resetAndShow();
          });
        }
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        const fromIndex = visibleCount;
        visibleCount = getMatchingCards().length;
        applyVisibility(true, fromIndex);
      });
    }

    resetAndShow();
    loadExtraCollectionPages().then(() => {
      resetAndShow();
    });
  });

  /* References multi-card rail + case gallery */
  document.querySelectorAll('[data-references]').forEach((root) => {
    const track = root.querySelector('[data-ref-track]');
    const cards = track ? [...track.querySelectorAll('.references__card')] : [];
    const btnPrev = root.querySelector('[data-ref-prev]');
    const btnNext = root.querySelector('[data-ref-next]');

    if (track && cards.length >= 2) {
      const scrollByCard = (dir) => {
        const card = cards[0];
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const amount = card.getBoundingClientRect().width + gap;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };

      if (btnPrev) btnPrev.addEventListener('click', () => scrollByCard(-1));
      if (btnNext) btnNext.addEventListener('click', () => scrollByCard(1));
    }

    const galleries = [...root.querySelectorAll('[data-case-gallery]')];
    let activeGallery = null;

    const closeCaseGallery = () => {
      if (!activeGallery) return;
      activeGallery.setAttribute('hidden', '');
      activeGallery = null;
      document.body.style.overflow = '';
    };

    const openCaseGallery = (id) => {
      const gallery = root.querySelector(`#CaseGallery-${id}`);
      if (!gallery) return;
      closeCaseGallery();
      gallery.removeAttribute('hidden');
      activeGallery = gallery;
      document.body.style.overflow = 'hidden';
      const closeBtn = gallery.querySelector('[data-case-close].case-gallery__close');
      if (closeBtn) closeBtn.focus();
    };

    root.querySelectorAll('[data-case-open]').forEach((btn) => {
      btn.addEventListener('click', () => openCaseGallery(btn.getAttribute('data-case-open')));
    });

    galleries.forEach((gallery) => {
      gallery.querySelectorAll('[data-case-close]').forEach((el) => {
        el.addEventListener('click', closeCaseGallery);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !activeGallery) return;
      const lb = document.querySelector('[data-product-lightbox]');
      if (lb && lb.classList.contains('is-open')) return;
      closeCaseGallery();
    });
  });

  /* Manufacturing page: reveal + counters + video */
  const mfgReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const formatCountValue = (value, format) => {
    const rounded = Math.round(value);
    if (format === 'comma') return rounded.toLocaleString('en-US');
    return String(rounded);
  };

  const animateCounter = (el) => {
    const target = Number(el.getAttribute('data-count-to')) || 0;
    const suffix = el.getAttribute('data-count-suffix') || '';
    const format = el.getAttribute('data-count-format') || '';
    const duration = 1400;
    const start = performance.now();

    if (mfgReduceMotion) {
      el.textContent = formatCountValue(target, format) + suffix;
      return;
    }

    const tick = (now) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatCountValue(target * eased, format) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
      else el.textContent = formatCountValue(target, format) + suffix;
    };

    requestAnimationFrame(tick);
  };

  document.querySelectorAll('[data-mfg-reveal]').forEach((block) => {
    const reveal = () => {
      block.classList.add('is-revealed');
      const stats = block.querySelector('[data-mfg-stats]');
      if (!stats || stats.dataset.counted === 'true') return;
      stats.dataset.counted = 'true';
      stats.querySelectorAll('[data-count-to]').forEach((el, index) => {
        const parent = el.closest('.mfg-stat');
        window.setTimeout(() => {
          if (parent) parent.classList.add('is-hot');
          animateCounter(el);
        }, index * 120);
      });
    };

    if (mfgReduceMotion || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal();
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.22, rootMargin: '0px 0px -6% 0px' }
    );

    observer.observe(block);
    window.setTimeout(reveal, 1600);
  });

  document.querySelectorAll('[data-mfg-video]').forEach((wrap) => {
    const video = wrap.querySelector('video');
    const toggle = wrap.querySelector('[data-mfg-video-toggle]');
    const hint = wrap.querySelector('[data-mfg-video-hint]');
    if (!video || !toggle) return;

    const setPlaying = (playing) => {
      wrap.classList.toggle('is-playing', playing);
      if (hint) {
        if (playing) hint.setAttribute('hidden', '');
        else hint.removeAttribute('hidden');
      }
    };

    const play = () => {
      const result = video.play();
      if (result && typeof result.then === 'function') {
        result.then(() => setPlaying(true)).catch(() => setPlaying(false));
      } else {
        setPlaying(true);
      }
    };

    const pause = () => {
      video.pause();
      setPlaying(false);
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      if (video.paused) play();
      else pause();
    });

    video.addEventListener('click', () => {
      if (video.paused) play();
      else pause();
    });

    video.addEventListener('ended', () => setPlaying(false));
    video.addEventListener('pause', () => {
      if (!video.seeking) setPlaying(false);
    });
    video.addEventListener('play', () => setPlaying(true));
  });
})();

/* Contact form: prevent duplicate submissions */
(() => {
  const forms = document.querySelectorAll('[data-contact-form]');
  if (!forms.length) return;

  forms.forEach((form) => {
    const submitBtn = form.querySelector('[data-contact-submit]');
    if (!submitBtn || submitBtn.disabled) return;

    let locked = false;

    const lock = () => {
      locked = true;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.setAttribute('aria-disabled', 'true');
      const label = submitBtn.getAttribute('data-label-submitting');
      if (label) submitBtn.textContent = label;
    };

    form.addEventListener('submit', (event) => {
      if (locked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        return;
      }

      lock();
    });

    submitBtn.addEventListener('click', (event) => {
      if (locked || submitBtn.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
  });
})();
